import { useCallback, useState } from 'react';
import { downloadBase64AsPDF } from '@ibk/shared-utils';
import { useLazyGetRechargeReportQuery } from '../services/benefitApi';
export function useRechargeReport() {
    const [trigger] = useLazyGetRechargeReportQuery();
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    async function fetchReport(params, filename) {
        setIsError(false);
        setIsLoading(true);
        try {
            const result = await trigger(params).unwrap();
            if (result?.result) {
                downloadBase64AsPDF(result.result, filename);
            }
        }
        catch {
            setIsError(true);
        }
        finally {
            setIsLoading(false);
        }
    }
    const reset = useCallback(() => {
        setIsError(false);
        setIsLoading(false);
    }, []);
    return {
        isError,
        isLoading,
        fetchReport,
        reset,
    };
}
